import React, { useCallback, useEffect, useRef, useState } from "react";

import WallComment from "./wall_comment";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";
import ModalContentBase from "../modal/modal_content_base";
import WallsCommentsLikeUsers from "./walls_comments_like_users";

const WallComments = ({ wallId, currentUser, isFormShow }) => {
  const [commentReply, setCommentReply] = useState("");
  const [comments, setComments] = useState([]);
  const [reportComments, setReportComments] = useState([]);
  const [deleteCommentId, setDeleteCommentId] = useState([]);
  const [reportCommentId, setReportCommentId] = useState([]);
  const [commentIdForLikeUsers, setCommentIdForLikeUsers] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const deleteCommentConfirmRef = useRef(null);
  const reportCommentConfirmRef = useRef(null);
  const reportCommentCompleteRef = useRef(null);
  const modalLikeUsersRef = useRef(null);

  useEffect(
    () => {
      loadComments();
    },
    [wallId, loadComments]
  );

  const handleCommentReplyBtn = useCallback(
    () => {
      if (isLoading) return;
      setIsLoading(true);
      const formData = new FormData();
      formData.append("comment", commentReply);
      formData.append("wall_id", wallId);
      $.ajax({
        url: "/api/walls/walls_comment_write",
        type: "POST",
        cache: false,
        headers: {
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        },
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(() => {
          loadComments();
          setCommentReply("");
          setIsLoading(false);
        })
        .fail(() => {
          setIsLoading(false);
        });
    },
    [
      isLoading,
      setIsLoading,
      commentReply,
      wallId,
      loadComments,
      setCommentReply,
    ]
  );

  const loadComments = useCallback(
    () => {
      $.ajax({
        url: "/api/walls/walls_comments",
        type: "GET",
        cache: false,
        data: {
          wall_id: wallId,
        },
        contentType: false,
      })
        .done((data) => {
          setComments(data.wallsComments);
        })
        .fail(() => {});
    },
    [wallId, setComments]
  );

  const handleDeleteCommentBtn = useCallback(
    (commentId) => {
      setDeleteCommentId(commentId);
      deleteCommentConfirmRef.current.openModal();
    },
    [setDeleteCommentId, deleteCommentConfirmRef]
  );

  const handleReportCommentBtn = useCallback(
    (commentId) => {
      setReportCommentId(commentId);
      reportCommentConfirmRef.current.openModal();
    },
    [setReportCommentId, reportCommentConfirmRef]
  );

  const deleteComment = useCallback(
    () => {
      const formData = new FormData();
      formData.append("walls_comment_id", deleteCommentId);
      $.ajax({
        url: "/api/walls/delete_comment",
        type: "POST",
        cache: false,
        headers: {
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        },
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(() => {
          setComments((v) =>
            v.filter((comment) => comment.id !== deleteCommentId)
          );
        })
        .fail(() => {});
    },
    [deleteCommentId, setComments]
  );

  const reportComment = useCallback(
    () => {
      const formData = new FormData();
      formData.append("walls_comment_id", reportCommentId);
      $.ajax({
        url: "/api/walls_comments_violations",
        type: "POST",
        cache: false,
        headers: {
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        },
        data: formData,
        processData: false,
        contentType: false,
      })
        .done(() => {
          setReportComments((v) =>
            v.filter((comment) => comment.id !== reportCommentId)
          );
        })
        .fail(() => {});
    },
    [reportCommentId, setReportComments]
  );

  const handleShowLikeUsersButton = useCallback(
    (commentId) => {
      setCommentIdForLikeUsers(commentId);
      modalLikeUsersRef.current.openModal();
    },
    [setCommentIdForLikeUsers, modalLikeUsersRef]
  );

  return (
    <div className="comment-reply-box mt-2 mb-2">
      {comments.map((comment) => (
        <WallComment
          key={comment.id}
          comment={comment}
          handleDeleteCommentBtn={handleDeleteCommentBtn}
          handleReportCommentBtn={handleReportCommentBtn}
          handleShowLikeUsersButton={handleShowLikeUsersButton}
          currentUser={currentUser}
        />
      ))}
      {isFormShow && currentUser && !currentUser.is_banned ? (
        <div className="input-group pt-3 pb-0">
          <textarea
            className="form-control border-0 rounded h-1em bg-white text-fz-12px"
            style={{ height: 51 }}
            type="text"
            rows="1"
            placeholder="返信する..."
            onChange={(e) => setCommentReply(e.target.value)}
            value={commentReply}
          />
          <div className="input-group-append">
            <button
              className="btn text-black-50 text-fw-normal pt-1 text-fz-12px"
              onClick={handleCommentReplyBtn}
            >
              返信
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
      <ModalConfirm
        ref={deleteCommentConfirmRef}
        title="コメントの削除"
        content="コメントを削除しますか？"
        approveFunc={deleteComment}
      />
      <ModalConfirm
        ref={reportCommentConfirmRef}
        title="コメントの通報"
        content="コメントを通報しますか？"
        approveFunc={reportComment}
      />
      <ModalAlert
        ref={reportCommentCompleteRef}
        title="完了"
        content="コメントの通報が完了しました。"
      />
      <ModalContentBase
        ref={modalLikeUsersRef}
        previewContent={<div />}
        modalContent={
          <WallsCommentsLikeUsers wallsCommentId={commentIdForLikeUsers} />
        }
      />
    </div>
  );
};

export default WallComments;
